import React from 'react';
import { Chip } from '@mui/material';
import { appColors } from '../../Config/Theme';

import { IncidentStatus } from '../../Types/enums';

interface IncidentStatusChipProps {
  status: string | number;
}

const IncidentStatusChip: React.FC<IncidentStatusChipProps> = ({ status }) => {
  const isActive = String(status).toLowerCase() === IncidentStatus.Active;

  return (
    <Chip
      label={isActive ? 'ACTIVE' : 'CLOSED'}
      size="small"
      sx={{
        fontWeight: 600,
        fontSize: '0.62rem',
        letterSpacing: '0.04em',
        borderRadius: '12px',
        height: 20,
        bgcolor: isActive ? 'rgba(46, 125, 50, 0.06)' : appColors.surface.inactive,
        color: isActive ? appColors.status.success : appColors.text.caption,
        border: isActive ? `1px solid ${appColors.status.successBorder}` : `1px solid ${appColors.border.subtle}`,
      }}
    />
  );
};

export default IncidentStatusChip;
